import {
  Tabs
} from "antd";
import {
  SearchOutlined
} from "@ant-design/icons";
import React, { useEffect } from "react";

import { observer, useSearchParams } from '@/store'
import Store from './store'
import Chunk from './add'

const App = (props) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const DevCode = searchParams.get("DevCode")
  useEffect(() => {

    Store.get_list("group1", DevCode)
  }, [])




  return (
    <>
      <Tabs onChange={(e) => {
        console.log(e);
        Store.get_list(e, DevCode)


      }}
        items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18].map((v, k) => { return { label: 'group' + v, key: 'group' + v, children: <Chunk key={'group' + v + Store.key} DevCode={DevCode}></Chunk> } })} />

    </>
  );
};

export default observer(App);
